import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M16 12H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 6H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 18H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 6v10a2 2 0 0 1-2 2h-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m16 16-2 2 2 2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ListEnd";
const ListEnd = memo(themed(Icon));
export {
  ListEnd
};
//# sourceMappingURL=list-end.js.map
